import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"white","padding":"13px 0","border-radius":"5px"}},[_c(VAlert,{staticStyle:{"margin":"0 13px"},attrs:{"color":"#4CAF50","type":"info","text":"","outlined":""}},[_c('span',{staticClass:"important-notice"},[_vm._t("noticeMessage")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }